export default {
  mounted(el) {
    const formatInput = (rawValue) => {
      // Elimina caracteres no válidos
      let clean = rawValue.replace(/[^\d.]/g, '');

      // Evita múltiples puntos
      const parts = clean.split('.');
      const intPart = parts[0].slice(0, 2); // max 2 dígitos enteros
      const decPart = (parts[1] || '').slice(0, 4); // max 4 decimales

      return intPart + (parts.length > 1 ? '.' : '') + decPart;
    };

    const padValue = (val) => {
      const [intPart = '', decPart = ''] = val.split('.');
      const paddedInt = intPart.padStart(2, '0').slice(0, 2);
      const paddedDec = (decPart + '0000').slice(0, 4);
      return `${paddedInt}.${paddedDec}`;
    };

    const limitRange = (val) => {
      const num = parseFloat(val);
      if (isNaN(num)) return '00.0000';
      if (num > 99.9999) return '99.9999';
      if (num < 0) return '00.0000';
      return padValue(val);
    };

    el.addEventListener('input', (e) => {
      const { value, selectionStart } = e.target;

      const formatted = formatInput(value);
      const addedChars = formatted.length - value.length;

      e.target.value = formatted;

      // Corrige la posición del cursor
      const newPos = Math.max(0, (selectionStart || 0) + addedChars);
      requestAnimationFrame(() => {
        e.target.setSelectionRange(newPos, newPos);
      });

      e.target.dispatchEvent(new Event('input'));
    });

    el.addEventListener('blur', (e) => {
      const final = limitRange(e.target.value);
      e.target.value = final;
      e.target.dispatchEvent(new Event('input'));
    });
  }
};
